import {
    ESharedFunction,
    ESharedFunctionMultiple,
} from "motw_core/Enums/ESharedFunction";
import { State } from "./State";

export async function SetState<TState>(
    name: ESharedFunction,
    newState: Partial<TState>,
    shouldMergeStates: boolean = true
): Promise<void> {
    const sharedFunction = CanSetState(name);
    const sharedFunctionName = ESharedFunction[name];

    if (sharedFunction) {
        // In javascript the type of an array is also 'object', so added this explicit check
        if (Array.isArray(newState)) {
            sharedFunction.setState(newState);
            return;
        }

        if (typeof newState === "object") {
        //    // Debugging: 
        //     console.log(
        //         `calling setstate for the sharedFunction '${sharedFunctionName}'`
        //     );

            sharedFunction.setState((prevState: TState) => {
                var mergedStates = MergeStates(
                    prevState,
                    newState,
                    shouldMergeStates
                );

                return mergedStates;
            });

            return;
        }

        sharedFunction.setState(newState);
    } else {
        const componentName = ESharedFunction[name];

        console.error(
            `Unable to update the state for the function component "${componentName}" with new state: ${JSON.stringify(
                newState
            )}. It looks like this component hasn't been mounted! See this error's call stack to find out who called this method. Alternatively, use CanSetState() before trying to set the state.`
        );
    }
}

export function CanSetState(name: ESharedFunction) {
    return State.ReadFunction(name);
}

export function SetStateMultiple<TState, K extends keyof TState>(
    name: ESharedFunctionMultiple,
    uniqueKey: string,
    newState: Partial<TState>,
    shouldMergeStates: boolean = true
): void {
    const sharedFunction = CanSetStateMultiple(name, uniqueKey);

    if (sharedFunction) {
        // In javascript the type of an array is also 'object', so added this explicit check
        if (Array.isArray(newState)) {
            sharedFunction.setState(newState);
            return;
        }

        if (typeof newState === "object") {
            sharedFunction.setState((prevState: TState) =>
                MergeStates(prevState, newState, shouldMergeStates)
            );

            return;
        }

        sharedFunction.setState(newState);
    } else {
        const componentName = ESharedFunction[name];

        console.error(
            `Unable to update the state for the function component "${componentName}" with new state: ${JSON.stringify(
                newState
            )}. It looks like this component hasn't been mounted! See this error's call stack to find out who called this method. Alternatively, use CanSetState() before trying to set the state.`
        );
    }
}

export function CanSetStateMultiple(
    name: ESharedFunctionMultiple,
    uniqueKey: string
) {
    return State.ReadFunctionMultiple(name, uniqueKey);
}

function MergeStates<TState>(
    prevState: TState,
    newState: Partial<TState>,
    shouldMergeStates: boolean
) {
    if (!shouldMergeStates) {
        return newState;
    }

    var mergedState = Object.assign({}, prevState, newState);
    return mergedState;
}
